import { IconLayer, ScatterplotLayer } from '@deck.gl/layers';

import { Optional } from '@angular/core';

import { COLORS, THEME, THEME_RGB_ARR } from '@lib/ui/theme';

import { FsLprCamera, LprCameraModel } from '../../api/models';

export class FsLprCameraWebGlScatterPlotLayer {
  private _lprCameraModels: LprCameraModel[] = [];
  private _lprCameras: FsLprCamera[] = [];
  private _iconLayer: IconLayer;
  private _scatterplotLayer: ScatterplotLayer;

  constructor(public data: FsLprCamera[] | LprCameraModel[], @Optional() public options?: any) {
    const oneDayAgo = new Date();
    oneDayAgo.setDate(oneDayAgo.getDate() - 1);
    data.forEach((camera) => {
      if (camera.properties?.hasOwnProperty('heading')) {
        this._lprCameraModels.push(camera);
      } else {
        this._lprCameras.push(camera);
      }
    });
    this._iconLayer = new IconLayer({
      id: 'fs__icon-layer',
      data: this._lprCameraModels,
      getSize: 34,
      getIcon: (d) => {
        const lastEvent = new Date(d.properties?.last_event);
        const url =
          lastEvent.getTime() <= oneDayAgo.getTime()
            ? '/assets/fusus-icons/PNG/PointedArrowYellow.png'
            : '/assets/fusus-icons/PNG/PointedArrow.png';
        return {
          url,
          width: 64,
          height: 64,
        };
      },
      pickable: true,
      aplhaCutoff: 0,
      getPosition: (d) => d.geometry?.coordinates || [d.longitude, d.latitude] || [0, 0],
      getAngle: (d) => -d.properties.heading,
    });
    this._scatterplotLayer = new ScatterplotLayer({
      id: 'fs__scatterplot-layer',
      data: this._lprCameras,
      opacity: 1,
      stroked: true,
      filled: true,
      radiusScale: 2,
      radiusMinPixels: 10,
      radiusMaxPixels: 10,
      pickable: true,
      lineWidthMinPixels: 2,
      lineWidthMaxPixels: 2,
      getPosition: (d) => d.position.coordinates,
      getRadius: () => 10,
      getFillColor: (d) => {
        if (d.type?.toString()?.toLowerCase()?.includes('vigilant')) {
          return [200, 200, 200];
        }
        return THEME_RGB_ARR['fusus-dark'];
      },
      getLineColor: (d) =>
        d.up ? this._hexToRgb(THEME.success) : this._hexToRgb(COLORS['amber-300']),
    });
  }

  public getLayer(): IconLayer | ScatterplotLayer {
    return [this._scatterplotLayer, this._iconLayer];
  }

  private _hexToRgb(hexColor: string): number[] {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexColor);
    return result
      ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)]
      : [0, 0, 0];
  }
}
